import { ICard } from '../original';

export const cards_VOS: ICard[] = [
  {
    id: 'EQIoDGs7MTeUGf_MTcbYz',
    value: 9,
    name: 'bounty',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888442/bang/valley%20of%20shadows/07_taglia_fqzwvn.png',
    suit: 'clubs',
    type: 'equipment',
    isTargeted: true,
  },
  {
    id: 'f3tyX2n0vA_GjPX6WVAGy',
    value: 9,
    name: 'ghost',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888440/bang/valley%20of%20shadows/07_fantasma_vbgxxt.png',
    suit: 'spades',
    type: 'equipment',
    isTargeted: true,
  },
  {
    id: 'Cj67M_sOmVhVGeEIX4n_U',
    value: 10,
    name: 'ghost',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888440/bang/valley%20of%20shadows/07_fantasma_vbgxxt.png',
    suit: 'spades',
    type: 'equipment',
    isTargeted: true,
  },
  {
    id: '2otkZLj18UFA5Ks3jNiq-',
    value: 4,
    name: 'lemat',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888441/bang/valley%20of%20shadows/07_lemat_fmlaxe.png',
    suit: 'diamond',
    type: 'equipment',
    isTargeted: false,
  },
  {
    id: 'F-nzaf9YNN3uGb9_gZ5Ma',
    value: 7,
    name: 'rattlesnake',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888441/bang/valley%20of%20shadows/07_serpenteasonagli_hzqbw9.png',
    suit: 'hearts',
    type: 'equipment',
    isTargeted: true,
    timer: 0,
  },
  {
    id: 'AdWE57t82ZVRF7oi34xvY',
    value: 13,
    name: 'shotgun',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888442/bang/valley%20of%20shadows/07_shotgun_egcipc.png',
    suit: 'spades',
    type: 'equipment',
    isTargeted: false,
  },
  {
    id: 'Clqo3hQ-jsw6qBr50qStn',
    value: 6,
    name: 'aim',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888441/bang/valley%20of%20shadows/07_mira_mwmfi5.png',
    suit: 'clubs',
    type: 'action',
    isTargeted: true,
    playWithBang: true,
  },
  {
    id: 'fzNg6iKCRINTl1ccVoMOj',
    value: 12,
    name: 'backfire',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888441/bang/valley%20of%20shadows/07_ritornodifiamma_sjiyga.png',
    suit: 'clubs',
    type: 'action',
    isTargeted: true,
  },
  {
    id: 'xgYPpuc1HtmkYthtOW7PW',
    value: 12,
    name: 'bandidos',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888441/bang/valley%20of%20shadows/07_bandidos_tn7pge.png',
    suit: 'diamond',
    type: 'action',
    isTargeted: false,
  },
  {
    id: '9ZW4_WBE0hc4zPwcMTPy9',
    value: 3,
    name: 'escape',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888441/bang/valley%20of%20shadows/07_fuga_jca9rd.png',
    suit: 'hearts',
    type: 'action',
    isTargeted: false,
  },
  {
    id: 'H93uGYD4UH7VwBDuyOCP_',
    value: 2,
    name: 'fanning',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888442/bang/valley%20of%20shadows/07_sventagliata_be5tbq.png',
    suit: 'spades',
    type: 'action',
    isTargeted: true,
  },
  {
    id: 'afKNdp1uuJNak3sT9EYgF',
    value: 8,
    name: 'last call',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888442/bang/valley%20of%20shadows/07_ultimogiro_njn4jx.png',
    suit: 'diamond',
    type: 'action',
    isTargeted: false,
  },
  {
    id: 'NkCQBOkYlWrvHlAHF5sI_',
    value: 11,
    name: 'poker',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888441/bang/valley%20of%20shadows/07_poker_crcfaq.png',
    suit: 'hearts',
    type: 'action',
    isTargeted: false,
  },
  // {
  //   id: 'Z3EswuCwZ4I2PXp84V8ZT',
  //   value: 5,
  //   name: 'saved',
  //   imageUrl:
  //     'https://res.cloudinary.com/trungpham/image/upload/v1606888441/bang/valley%20of%20shadows/07_salvo_ee8b1m.png',
  //   suit: 'hearts',
  //   type: 'action',
  //   isTargeted: true,
  // },
  {
    id: 'k3FiuLJHWCbq-DKLRgiPu',
    value: 14,
    name: 'tomahawk',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888442/bang/valley%20of%20shadows/07_tomahawk_vz2nzo.png',
    suit: 'diamond',
    type: 'action',
    isTargeted: true,
  },
  {
    id: 'dINddJbjCnFUxWmf9G3fJ',
    value: 14,
    name: 'tornado',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888442/bang/valley%20of%20shadows/07_tornado_g2xesa.png',
    suit: 'clubs',
    type: 'action',
    isTargeted: false,
  },
];

export const cards_DodgeCity: ICard[] = [
  {
    id: '1j1xVnloIQ5zZH07254Lq',
    value: 14,
    name: 'barrel',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888948/bang/original/barile_z8ibbs.png',
    suit: 'clubs',
    type: 'equipment',
    isTargeted: false,
  },
  {
    id: 'TMtEotOCBc0TY43XIhcos',
    value: 10,
    name: 'binocular',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888454/bang/dodge%20city/03_binocolo_laikrj.png',
    suit: 'diamond',
    type: 'equipment',
    isTargeted: false,
  },
  {
    id: 'zOlEsj972wAvTrr5by2PF',
    value: 10,
    name: 'dynamite',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888949/bang/original/dynamite_gq525m.png',
    suit: 'clubs',
    type: 'equipment',
    isTargeted: false,
    timer: 1,
  },
  {
    id: 'yxHrvWbFDU3rFgWkWAIli',
    value: 10,
    name: 'hideout',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888457/bang/dodge%20city/03_riparo_pmkcax.png',
    suit: 'clubs',
    type: 'equipment',
    isTargeted: false,
  },
  {
    id: 'T3bACXeYZbffIWomM34JQ',
    value: 5,
    name: 'mustang',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888950/bang/original/mustang_pht7ms.png',
    suit: 'hearts',
    type: 'equipment',
    isTargeted: false,
  },
  {
    id: '9FfznwQQExlurC4FoggPW',
    value: 6,
    name: 'remington',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888950/bang/original/remington_dtsgzi.png',
    suit: 'diamond',
    type: 'equipment',
    isTargeted: false,
  },
  {
    id: '9zwj4YUe9rJGdR1CcU6tg',
    value: 5,
    name: 'rev carabine',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888949/bang/original/carabine_czyogt.png',
    suit: 'spades',
    type: 'equipment',
    isTargeted: false,
  },
  {
    id: 'BnoahMtyEopebo8hGa62v',
    value: 8,
    name: 'bang',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888948/bang/original/bang_elk9mw.png',
    suit: 'spades',
    type: 'action',
    isTargeted: true,
  },
  {
    id: 'BMtEW_EqA9wZp76cZ7T25',
    value: 5,
    name: 'bang',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888948/bang/original/bang_elk9mw.png',
    suit: 'clubs',
    type: 'action',
    isTargeted: true,
  },
  {
    id: '8W4F3b1407RMl6WBRuWxi',
    value: 6,
    name: 'bang',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888948/bang/original/bang_elk9mw.png',
    suit: 'clubs',
    type: 'action',
    isTargeted: true,
  },
  {
    id: 'bjdWSEmInNIHwwucrnfA3',
    value: 7,
    name: 'bang',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888948/bang/original/bang_elk9mw.png',
    suit: 'clubs',
    type: 'action',
    isTargeted: true,
  },
  {
    id: 'wD8-u0JNP0l4_DqDXEAgq',
    value: 6,
    name: 'beer',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888949/bang/original/birra_hjgptv.png',
    suit: 'hearts',
    type: 'action',
    isTargeted: false,
  },
  {
    id: 'oulIRI4_gJO3Rh1kcktaS',
    value: 6,
    name: 'beer',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888949/bang/original/birra_hjgptv.png',
    suit: 'spades',
    type: 'action',
    isTargeted: false,
  },
  {
    id: '8vpyI5yvMRawbWEXwLpK5',
    value: 8,
    name: 'cat balou',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888949/bang/original/catbalou_fihyoi.png',
    suit: 'clubs',
    type: 'action',
    isTargeted: true,
  },
  {
    id: '2JWSNSUDTLVfBoZAY3VmG',
    value: 14,
    name: 'general store',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888949/bang/original/emporio_ldjfxn.png',
    suit: 'spades',
    type: 'action',
    isTargeted: false,
  },
  {
    id: 'Rh2f5nrVBWyaT6zp0OOvU',
    value: 5,
    name: 'indians',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888949/bang/original/indiani_mlfftz.png',
    suit: 'diamond',
    type: 'action',
    isTargeted: false,
  },
  {
    id: 'DrLyrXIuZAUVxEjJ1Br1j',
    value: 8,
    name: 'missed',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888950/bang/original/mancato_r2oh5w.png',
    suit: 'diamond',
    type: 'action',
    isTargeted: true,
  },
  {
    id: '-Mq5n5Q4PP-5i8iQazQzS',
    value: 11,
    name: 'panic',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1602888950/bang/original/panico_fdczgp.png',
    suit: 'hearts',
    type: 'action',
    isTargeted: true,
  },
  {
    id: 'Vl7kG4c3fJOD-Iysrl_pL',
    value: 10,
    name: 'punch',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888456/bang/dodge%20city/03_pugno_oapgw5.png',
    suit: 'spades',
    type: 'action',
    isTargeted: true,
  },
  {
    id: 'mGZ1N1HjQrZNOG1Mn2zne',
    value: 11,
    name: 'brawl',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888457/bang/dodge%20city/03_rissa_jwvmtm.png',
    suit: 'spades',
    type: 'action',
    isTargeted: false,
    needsDiscard: true,
  },
  {
    id: '316ICNQ3P-D_FBNFPySKz',
    value: 13,
    name: 'dodge',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888457/bang/dodge%20city/03_schivata_gwbp7a.png',
    suit: 'hearts',
    type: 'action',
    isTargeted: false,
  },
  {
    id: '4IUiP2I8bbtnRNeagudSK',
    value: 7,
    name: 'dodge',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888457/bang/dodge%20city/03_schivata_gwbp7a.png',
    suit: 'diamond',
    type: 'action',
    isTargeted: false,
  },
  {
    id: 'N1gbxQrdZ5TxcYQGntN8B',
    value: 9,
    name: 'rag time',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888456/bang/dodge%20city/03_rag_time_i4vvik.png',
    suit: 'hearts',
    type: 'action',
    isTargeted: false,
    needsDiscard: true,
  },
  {
    id: 'gt3vKZ44mfCFH0HAnwYMr',
    value: 13,
    name: 'springfield',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888457/bang/dodge%20city/03_springfield_wqihck.png',
    suit: 'spades',
    type: 'action',
    isTargeted: true,
    needsDiscard: true,
  },
  {
    id: 'm-u7bTTh1b4SWvPIRvyWR',
    value: 9,
    name: 'tequila',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888457/bang/dodge%20city/03_tequila_oirtpx.png',
    suit: 'clubs',
    type: 'action',
    isTargeted: true,
    needsDiscard: true,
  },
  {
    id: 'ih8szqljVCUo2neTH1gE_',
    value: 12,
    name: 'whisky',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888458/bang/dodge%20city/03_whisky_a7xeu5.png',
    suit: 'hearts',
    type: 'action',
    isTargeted: false,
    needsDiscard: true,
  },
  {
    id: 'A9bfbuKmS0L1WaFK377Uk',
    value: 10,
    name: 'bible',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888453/bang/dodge%20city/03_bibbia_wybqkm.png',
    suit: 'hearts',
    type: 'green',
    isTargeted: false,
    timer: 1,
  },
  {
    id: 'D_SY3dvYfr2STYqflL7YJ',
    value: 12,
    name: 'buffalo rifle',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888455/bang/dodge%20city/03_fucile_da_caccia_bvuddx.png',
    suit: 'clubs',
    type: 'green',
    isTargeted: true,
    timer: 1,
  },
  {
    id: 'UfuKgxMnzBv9gD3AzMVOe',
    value: 11,
    name: 'can can',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888454/bang/dodge%20city/03_can_can_g9g1fs.png',
    suit: 'clubs',
    type: 'green',
    isTargeted: true,
    timer: 1,
  },
  {
    id: 'G-hYD4n33XFVBdXyVW2kx',
    value: 7,
    name: 'canteen',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888454/bang/dodge%20city/03_borraccia_goxxde.png',
    suit: 'hearts',
    type: 'green',
    isTargeted: false,
    timer: 1,
  },
  {
    id: 'u5VoQkM5fZe2cfr_r1pgd',
    value: 9,
    name: 'conestoga',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888454/bang/dodge%20city/03_conestoga_w6xgyd.png',
    suit: 'diamond',
    type: 'green',
    isTargeted: true,
    timer: 1,
  },
  {
    id: 'AGEmuEyoghAGaTi8tcESn',
    value: 7,
    name: 'derringer',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888454/bang/dodge%20city/03_derringer_l0piyc.png',
    suit: 'spades',
    type: 'green',
    isTargeted: true,
    timer: 1,
  },
  {
    id: '9FVO03rRkYACxy9XSwHZl',
    value: 9,
    name: 'howitzer',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888455/bang/dodge%20city/03_howitzer_ffzq2g.png',
    suit: 'spades',
    type: 'green',
    isTargeted: false,
    timer: 1,
  },
  {
    id: '2sZu2cekILhMnszYtQvPG',
    value: 14,
    name: 'iron plate',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888456/bang/dodge%20city/03_placca_di_ferro_gyceky.png',
    suit: 'diamond',
    type: 'green',
    isTargeted: false,
    timer: 1,
  },
  {
    id: 'eT46V1DMPGS6ESFMJI_3f',
    value: 12,
    name: 'iron plate',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888456/bang/dodge%20city/03_placca_di_ferro_gyceky.png',
    suit: 'spades',
    type: 'green',
    isTargeted: false,
    timer: 1,
  },
  {
    id: 'Dnc7_DiUJsUtutei-4N0y',
    value: 8,
    name: 'knife',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888456/bang/dodge%20city/03_pugnale_kidolt.png',
    suit: 'hearts',
    type: 'green',
    isTargeted: true,
    timer: 1,
  },
  {
    id: '8h4HCnTAP_Ow_Vvn2YtXa',
    value: 14,
    name: 'pepperbox',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888456/bang/dodge%20city/03_pepperbox_hder4s.png',
    suit: 'hearts',
    type: 'green',
    isTargeted: true,
    timer: 1,
  },
  {
    id: 'TE3ohC3h5OkkMOhFWD1fU',
    value: 12,
    name: 'pony express',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888456/bang/dodge%20city/03_pony_express_ymswhj.png',
    suit: 'diamond',
    type: 'green',
    isTargeted: false,
    timer: 1,
  },
  {
    id: 'OUJZZy0LSm3rk2dOj_2UT',
    value: 7,
    name: 'sombrero',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888457/bang/dodge%20city/03_sombrero_qeq9ow.png',
    suit: 'clubs',
    type: 'green',
    isTargeted: false,
    timer: 1,
  },
  {
    id: 'VR39mDMiJh-KINdR1_GYs',
    value: 11,
    name: 'ten gallon hat',
    imageUrl:
      'https://res.cloudinary.com/trungpham/image/upload/v1606888454/bang/dodge%20city/03_cappello_uqibi7.png',
    suit: 'diamond',
    type: 'green',
    isTargeted: false,
    timer: 1,
  },
];
